var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tokenImage",class:{ char: !_vm.getImageIcon },style:({
    width: _vm.size + 'px',
    height: _vm.size + 'px',
    fontSize: _vm.size / 2 - 1 + 'px',
  })},[(_vm.getImageIcon)?_c('img',{staticClass:"logo",attrs:{"src":_vm.getImageIcon}}):[_vm._v(_vm._s(_vm.getCharIcon))],(_vm.isShowBadge)?_c('img',{staticClass:"badge",style:({ width: (_vm.size > 30 ? _vm.size / 4 * 3 : _vm.size) + 'px' }),attrs:{"src":require("@/assets/icons/100list.svg")}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }